// operator_inbox (console) — the queue of what the operator writes while a run works
// (platform-service/lib/operator_inbox.ts holds the rules; design_parler_pendant_un_run.md).
//
// Two deployables, so the rule the CONSOLE applies — when a run's end sends the queue — is written
// here too, and platform-service/lib/operator_inbox_parity.test.ts proves the two agree on every
// status rather than one importing the other.

/** One message waiting for the run to end, as the server stores it. */
export type QueuedMessage = { readonly id: string; readonly text: string; readonly at: string };

/** The queue as the server sent it — anything malformed is dropped, never shown as a message. */
export function inboxFromServer(raw: unknown): QueuedMessage[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter((m): m is QueuedMessage =>
    m !== null && typeof m === "object"
    && typeof (m as any).id === "string" && typeof (m as any).text === "string" && typeof (m as any).at === "string");
}

/** Does a run that ended with this status send the queue? Only one that FINISHED — done, or failed.
 *  Not `awaiting_reply` (an answer is owed, and the queue must not give it), not `aborted` (Stop
 *  starts nothing), not a status nobody decided about. */
export function autoSendAfter(status: string | null): boolean {
  return status === "done" || status === "error";
}

/** Is the composer QUEUEING right now? A run works, nothing waits on an answer, and the operator is
 *  asking for a change — a question in Chat mode is not something a build waits to hear. */
export function queueMode(s: { runActive: boolean; askPending: boolean; mode: "chat" | "act" }): boolean {
  return s.runActive && !s.askPending && s.mode === "act";
}
